module.exports = __webpack_public_path__ + "img/logo.b41808d4.svg";